import { AuthAction, AuthState } from './types';

const initalState: AuthState = {
  loadingSigninRequest: false,
  token: null,
  authType: 'smartsell',
  user: null,
  integrationModels: [],
  isSignin: false,
  expirationDate: null,
};

export default function auth(state = initalState, action: AuthAction): AuthState {
  switch (action.type) {
    case '@auth/SIGN_IN_BY_TOKEN_REQUEST':
      return {
        ...state,
        loadingSigninRequest: true,
      };

    case '@auth/SIGN_IN_SUCCESS':
      return {
        ...state,
        loadingSigninRequest: false,
        token: action.payload.token,
        user: action.payload.user,
        authType: action.payload.authType,
        isSignin: true,
        expirationDate: action.payload.expirationDate,
      };

    case '@auth/SET_INTEGRATION_MODELS':
      return {
        ...state,
        integrationModels: action.payload.IntegrationModels,
      };

    case '@auth/SIGN_IN_FAILURE':
      return {
        ...state,
        loadingSigninRequest: false,
      };

    case '@auth/LOGOUT_REQUEST':
      return {
        ...state,
        token: null,
        user: null,
        loadingSigninRequest: true,
        isSignin: false,
      };

    case '@auth/LOGOUT_SUCCESS':
      return {
        ...state,
        loadingSigninRequest: false,
        integrationModels: [],
      };
    case '@auth/REFRESH_REQUEST':
      return {
        ...state,
        loadingSigninRequest: true,
      };
    case '@auth/REFRESH_SUCCESS':
      return {
        ...state,
        loadingSigninRequest: false,
        token: action.payload.token,
      };
    case '@auth/REFRESH_FAILURE':
      return {
        ...state,
        loadingSigninRequest: false,
      };
    case '@auth/SET_STATUS_LOADING_LOGIN':
      return {
        ...state,
        loadingSigninRequest: action.payload.status,
      };

    default:
      return state;
  }
}
